/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipment_Booking_Not_AllowedInputs */

const en_error_shipment_booking_not_allowed = /** @type {(inputs: Error_Shipment_Booking_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLG Shipping books only DDP orders the warehouse has and has not shipped yet, and a booking cannot be withdrawn once the goods left.`)
};

/**
* | output |
* | --- |
* | "TLG Shipping books only DDP orders the warehouse has and has not shipped yet, and a booking cannot be withdrawn once the goods left." |
*
* @param {Error_Shipment_Booking_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_shipment_booking_not_allowed = /** @type {((inputs?: Error_Shipment_Booking_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipment_Booking_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_shipment_booking_not_allowed(inputs)
});